import sportsApi from '../../utils/sportsApi';

const fetchPlacements = async ({
    clientId,
    rightsholderId,
    sponsorId,
    useRightsholderAttribution = false,
}) => {
    const endPoint = `/clients/${clientId}/rightsholders/${rightsholderId}/sponsors/${sponsorId}/placements`;
    const placements = await sportsApi
        .url(endPoint)
        .query({
            restrictToNoEndDate: true,
            restrictToRspActive: true,
            ...(useRightsholderAttribution
                ? { useRightsholderAttribution: true }
                : {}),
        })
        .get()
        .json();

    if (!Array.isArray(placements)) {
        return [];
    }

    return placements
        .map(s => ({
            value: `${rightsholderId}-${s.id}`,
            name: s.name,
        }))
        .sort((a, b) => {
            return a.name.localeCompare(b.name);
        });
};

export default fetchPlacements;
